import React from 'react';
import downloadsData from '@/utils/downloadsData.json';

interface DownloadItem {
  title: string;
  description: string;
  fileSize: string;
  fileType: string;
  filePath: string;
}

interface DownloadCategoryData {
  category: string;
  items: DownloadItem[];
  subCategories: DownloadCategoryData[];
}

const handleDownload = (filePath: string) => {
  const fileName = filePath.split('/').pop() || 'file';
  const confirmed = window.confirm(`ファイル「${fileName}」をダウンロードしますか?`);
  if (!confirmed) return;

  // Extract the path relative to the 'docs' folder
  const relativePath = filePath.startsWith('/docs/') ? filePath.substring(6) : filePath;
  
  // The actual link will be to our PHP script
  const downloadUrl = `/download.php?file=${encodeURIComponent(relativePath)}`;

  // Navigate to this URL to trigger the download. 
  // The 'download' attribute is now handled by the PHP script's Content-Disposition header.
  window.location.href = downloadUrl;
  
  alert(`ファイル「${fileName}」のダウンロードを開始しました。`);
};

const DownloadCategory: React.FC<{ categoryData: DownloadCategoryData, isRoot?: boolean }> = ({ categoryData, isRoot = false }) => {
  const hasContent = categoryData.items.length > 0 || categoryData.subCategories.length > 0;
  if (!hasContent) {
    return null;
  }

  return (
    <div className={isRoot ? '' : 'download-subcategory'}>
      <h3>{categoryData.category}</h3>
      {categoryData.items.length > 0 && (
        <div className="download-items">
          {categoryData.items.map((item, itemIdx) => (
            <div key={itemIdx} className="download-item">
              <div className="download-info">
                <h4>{item.title}</h4>
                {item.description && <p>{item.description}</p>}
                <span className="file-info">
                  {item.fileType} / {item.fileSize}
                </span>
              </div>
              <button
                className="btn btn-outline download-btn"
                onClick={() => handleDownload(item.filePath)}
              >
                ダウンロード
              </button>
            </div>
          ))}
        </div>
      )}
      {categoryData.subCategories.length > 0 && (
        <div className="subcategories-container">
          {categoryData.subCategories.map((subCategory, subIdx) => (
            <DownloadCategory key={subIdx} categoryData={subCategory} />
          ))}
        </div>
      )}
    </div>
  );
};


export const DownloadPage: React.FC = () => {
  return (
    <main className="main-content">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">ダウンロード</h1>
          <p className="page-subtitle">
            WiCanvasに関する各種資料をダウンロードいただけます。製品カタログから技術仕様書まで、導入検討に必要な資料を豊富にご用意しています。
          </p>
          <p className="page-note">
            ※ 取扱説明書などの詳細資料の閲覧には専用のアカウントが必要です。アカウントをお持ちでない方は、
            <a href="/#contact">お問い合わせフォーム</a>
            よりお申し込みください。内容を確認の上、発行させていただきます。
          </p>
        </div>

        <section className="downloads">
          <div className="terms-notice">
            <h2>取扱説明書のご利用にあたって</h2>
            <p>
              取扱説明書をダウンロードされる前に、必ず「取扱説明書利用規約・免責事項」をご確認いただき、同意の上でご利用ください。
            </p>
            <a 
              href="/pdf/terms-use-20250305.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline terms-btn"
            >
              <span className="icon">📋</span>
              取扱説明書利用規約・免責事項 (PDF)
            </a>
          </div>
...
          <div className="download-categories">
            {downloadsData.subCategories.map((category, idx) => (
              <div key={idx} className="download-category">
                <DownloadCategory categoryData={category} isRoot={true} />
              </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
};
